/***
 * @file:
 * @author: linkun.he
 * @Date: 2020-05-22 14:28:13
 */
import { forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { specialCharacterRe } from './regex';

export function customInputControlValueAccessor(instance) {
  const provide = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => instance),
    multi: true,
  };

  return provide;
}

export const noop = () => { };

/**
 * @description åæ¢è¡¨åæ§ä»¶çéèåæ¾ç¤º
 * @param formConf è¡¨åéç½®ä¿¡æ¯
 * @param props è¢«æä½çå±æ§ (è¿ééè¦æ°ç»)
 * @param isEmptyValue boolean æ¯å¦éè¦å°éèçæ§ä»¶ç½®ç©º
 * @param form è¡¨åæ°æ®
 */
export const switchLooming = (formConf: any, props: any[], isEmptyValue?: boolean, form?: any) => {
  formConf.forEach((item) => {
    if (props.some((t) => t === item.prop)) {
      item['hide'] = !item['hide'];
      if (isEmptyValue) {
        form[item.prop] = handleDataProperty(form[item.prop]);
      }
    }
  });
  return form;
};

/**
 * @description å°é¨åæ§ä»¶å±æ§ç½®ç©º
 * @param form è¡¨åæ°æ®
 * @param props è¢«æä½çå±æ§
 */
export const resetFormData = (form?: any, ...props) => {
  Object.keys(form).forEach((key) => {
    if (props.some((t) => t === key)) {
      form[key] = handleDataProperty(form[key]);
    }
  });
  delete form.value;
  delete form.prop;
  return form;
};

function handleDataProperty(data) {
  if (Object.prototype.toString.call(data) === '[object Array]') {
    return [];
  }
  if (Object.prototype.toString.call(data) === '[object Boolean]') {
    return false;
  }
  if (Object.prototype.toString.call(data) === '[object String]') {
    return '';
  }
  return null;
}

// å»é¤å­ç¬¦ä¸²ä¸­çç¹æ®å­ç¬¦
export function deleteSpecialCharacter(data: string): string {
  let result = '';
  for (let i = 0; i < data.length; i++) {
    result += data.substr(i, 1).replace(specialCharacterRe, '');
  }
  return result;
}
